module.exports = __webpack_public_path__ + "static/media/YeeLee.b33e7b78.png";